import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export default dayjs;

export const dateFormatOptions = {
  us1: 'MM/dd/yy - HH:mm',
  'us1-long': 'MM/dd/yyyy - HH:mm',
  iso1: 'yyyy-MM-dd - HH:mm',
  aussie: 'dd-MM-yy - HH:mm',
  'aussie-long': 'dd-MM-yyyy - HH:mm',
  lll: 'MMM dd, yyyy - HH:mm ',
};
